module.exports = __webpack_public_path__ + "img/reportDownload.fb327c11.jpg";